import "./styles/PhoneFrame.css";

interface PhoneFrameProps {
  src: string;
  alt: string;
  className?: string;
  isEager?: boolean;
}

// The screenshots are 375 × 812, the app on a phone; the frame is only CSS.
export function PhoneFrame({ src, alt, className, isEager = false }: PhoneFrameProps) {
  return (
    <figure className={className ? `phone-frame ${className}` : "phone-frame"}>
      <div className="phone-frame__screen">
        <img src={src} alt={alt} width={375} height={812} loading={isEager ? "eager" : "lazy"} decoding="async" />
      </div>
    </figure>
  );
}
